<nav
  class="bg-background gap-4 px-24 py-16 flex justify-between items-center"
>
  <div class="flex flex-row items-center gap-4">
    <img
      ngSrc="assets/media/enac-logo.png"
      alt="ENAC"
      height="75"
      width="52"
      priority />
    <div class="flex flex-col">
      <h1 class="text-2xl font-semibold">{{ 'TITLE' | translate }}</h1>
      <h2 class="text-primary flex items-center gap-1">
        @if (storageStateService.folder()) {
          <mat-icon class="material-symbols-outlined">folder</mat-icon>
          {{ storageStateService.folder().name }}
        }
      </h2>
    </div>
  </div>
    <div>
      <button
        mat-icon-button
        class="custom-button w-15! h-15!"
        [matMenuTriggerFor]="userMenu"
        [attr.aria-label]="'NAV.ARIA_LABELS.USER_MENU' | translate"
      >
        <mat-icon class="material-symbols-outlined">
          person
        </mat-icon>
      </button>
      <mat-menu #userMenu="matMenu" class="custom-mat-menu p-4!">
        <span> {{ user().firstName + ' ' + user().lastName}}</span>
        <button mat-menu-item (click)="signOut()">
          <label>Logout</label>
          <mat-icon class="material-symbols-outlined">logout</mat-icon>
        </button>
      </mat-menu>
    </div>
</nav>
